module.exports = __webpack_public_path__ + "static/media/transfer.78cd2f2f.svg";